import React, { useState, useEffect } from 'react';

/*
const GENRE_MAP = {
  pop: { n: 'Pop', k: true },
  rock: { n: 'Rock', k: true },
  hiphop: { n: 'Hip Hop', k: true },
  jazz: { n: 'Jazz', k: true },
  electronic: { n: 'Electronic', k: false },
  classical: { n: 'Classical', k: false },
  reggae: { n: 'Reggae', k: false },
  country: { n: 'Country', k: false },
  rnb: { n: 'R&B', k: false },
  metal: { n: 'Metal', k: false },
};
*/

const COUNTRIES = ["Q258", "Q262", "Q265", "Q298", "Q334", "Q347", "Q398", "Q399", "Q408", "Q414", "Q423", "Q424", "Q574", "Q657", "Q664", "Q668", "Q672", "Q683", "Q686", "Q685", "Q691", "Q695", "Q697", "Q702", "Q711", "Q712", "Q717", "Q734", "Q733", "Q739", "Q736", "Q750", "Q754", "Q757", "Q763", "Q760", "Q766", "Q769", "Q774", "Q778", "Q783", "Q781", "Q786", "Q784", "Q792", "Q16", "Q17", "Q20", "Q27", "Q30", "Q31", "Q28", "Q29", "Q34", "Q35", "Q32", "Q33", "Q38", "Q39", "Q36", "Q37", "Q43", "Q40", "Q41", "Q45", "Q55", "Q79", "Q77", "Q96", "Q114", "Q115", "Q117", "Q142", "Q145", "Q148", "Q155", "Q159", "Q183", "Q184", "Q191", "Q189", "Q211", "Q214", "Q215", "Q213", "Q218", "Q219", "Q222", "Q221", "Q227", "Q224", "Q225", "Q228", "Q229", "Q232", "Q233", "Q236", "Q237", "Q241", "Q252", "Q219060", "Q756617", "Q16112782", "Q124153644", "Q794", "Q796", "Q800", "Q801", "Q805", "Q810", "Q811", "Q813", "Q819", "Q822", "Q826", "Q833", "Q836", "Q837", "Q842", "Q843", "Q846", "Q851", "Q854", "Q858", "Q863", "Q865", "Q869", "Q874", "Q878", "Q881", "Q884", "Q889", "Q902", "Q912", "Q916", "Q917", "Q921", "Q924", "Q928", "Q929", "Q945", "Q948", "Q954", "Q953", "Q958", "Q962", "Q963", "Q967", "Q965", "Q970", "Q971", "Q974", "Q977", "Q986", "Q1000", "Q1006", "Q1005", "Q1011", "Q1008", "Q1009", "Q1014", "Q1013", "Q1016", "Q1020", "Q1027", "Q1025", "Q1030", "Q1028", "Q1032", "Q1033", "Q1039", "Q1036", "Q1037", "Q1042", "Q1041", "Q1044", "Q1045", "Q1049", "Q1246", "Q21203", "Q26273", "Q26988", "Q29999", "Q34020", "Q488889", "Q131839713", "Q804", "Q817", "Q983", "Q1007", "Q1019", "Q1029", "Q1050", "Q43287", "Q403", "Q419", "Q678", "Q710", "Q709", "Q730", "Q790", "Q212", "Q217", "Q230", "Q235", "Q238", "Q242", "Q244"]

/*
const LOCATION_MAP = {
  nearby: { n: ' * NEAR ME * ', k: true },
  ny: { n: 'New York', k: true },
  la: { n: 'Los Angeles', k: true },
  london: { n: 'London', k: true },
  paris: { n: 'Paris', k: true },
  tokyo: { n: 'Tokyo', k: true },
  montreal: { n: 'Montreal', k: false },
  berlin: { n: 'Berlin', k: false },
  toronto: { n: 'Toronto', k: false },
  atlanta: { n: 'Atlanta', k: false },
  seoul: { n: 'Seoul', k: false },
};
*/

const POPULARITIES = ['1B+', '100M+', '50M+', '10M+', '5M+', '1M+', '100K+', '10K+'];

const SORTBY = ['Earliest', 'Latest', 'Most Viewed', 'Least Viewed', 'Most Played by me', 'Least Played by me'];

const MAPOPTIONS = ['Below', 'Beside', 'No Map'];

const style = document.createElement('style');
style.textContent = `
  .playlist-filter-container {
    max-width: 600px;
    margin: auto;
    padding: 1.5rem;
    font-family: sans-serif;
  }

  .section-toggle {
    background-color: #f3f4f6;    
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.01rem;
    padding-bottom: 0.01rem;
    border-radius: 0.375rem;
    cursor: pointer;
    margin-bottom: 1rem;
  }

  .section-toggle h2 {
    font-size: 2.5rem;
    font-weight: 600;
    text-align: left;
  }

  .section-content {
    margin-top: 0.5rem;
    margin-bottom: 2rem;
  }

  .button-group {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
    margin-top: 0.5rem;
  }

  .option-button {
    padding: 0.375rem 0.75rem;
    font-size: 2.5rem;
    border-radius: 9999px;
    border: 1px solid #d1d5db;
    background-color: #f9fafb;
    cursor: pointer;
  }

  .option-button.selected {
    background-color: #3b82f6;
    color: white;
    border-color: #3b82f6;
  }

  .option-button2 {
    padding: 0.375rem 0.75rem;
    font-size: 2.5rem;
    border-radius: 5px;
    width: 100%;
    border: 1px solid #d1d5db;
    background-color: #f9fafb;
    cursor: pointer;
  }

  .option-button2.selected {
    background-color: #3b82f6;
    color: white;
    border-color: #3b82f6;
  }

  .search-input {
    width: 97.5%;
    font-size: 3rem;
    padding: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0rem;
    margin-bottom: 1.5rem;
    border-radius: 0.375rem;
    border: 1px solid #d1d5db;
  }
  .span-text {
    text-align: center;
    text-vertical-align: middle;
    valign: middle;
    font-size: 3rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .generate-button {
    background-color: #3b82f6;
    color: white;
    padding: 0.75rem 1.5rem;
    font-size: 3rem;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    cursor: pointer;
  }

  .clear-button {
    text-align: right;
    color: #dc2626;
    font-size: 0.875rem;
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 0.5rem;
  }
`;
document.head.appendChild(style);




export default function PlaylistFilter({ componentId, keyLocations, citiesIDs, keyTags, savedState, submit }) {  
  const [mode, setMode] = useState(savedState?.mode || 'top');
  const [genres, setGenres] = useState(savedState?.genres || []);
  const [genreSearch, setGenreSearch] = useState(savedState?.genreSearch || '');
  const [yearRange, setYearRange] = useState(savedState?.yearRange || [-40000, 2026]);
  const [locations, setLocations] = useState(savedState?.locations || []);
  const [locationSearch, setLocationSearch] = useState(savedState?.locationSearch || '');
  const [popularity, setPopularity] = useState(savedState?.popularity || null);
  const [sortBy, setSortBy] = useState(savedState?.sortBy || 0);
  const [mapOption, setMapOption] = useState(savedState?.mapOption || "Below");
  const [nearby, setNearBy] = useState(savedState?.nearby || false);
  const [showSuggestions, setShowSuggestions] = useState(savedState?.showSuggestions || false);
  const [openSteps, setOpenSteps] = useState(savedState?.openSteps || { 1: true, 2: false, 3: false, 4: false, 5: false, 6: false, 7: true });
  
  const toggleStep = (stepNum) => {
    setOpenSteps(prev => ({ ...prev, [stepNum]: !prev[stepNum] }));
  };

  const toggleGenre = (id) => {
    setGenres(prev => prev.includes(id) ? prev.filter(g => g !== id) : [...prev, id]);
  };

  const toggleLocation = (id) => {
    setLocations(prev => prev.includes(id) ? prev.filter(l => l !== id) : [...prev, id]);
  };

  const toggleShowSuggestions = () => {
    setShowSuggestions(prev => !prev);
    setLocationSearch(''); // Clear search when toggling suggestions
  };

  const toggleNearBy = () => {
    setNearBy(prev => !prev);
  }

  //transform countries into a boolean map
  const countriesIDs = COUNTRIES.reduce((acc, id) => {
    acc[id] = true;
    return acc;
  }, {});

  //const genreEntries = Object.entries(GENRE_MAP);
  //const locationEntries = Object.entries(LOCATION_MAP);
  const genreEntries = Object.entries(keyTags);
  const locationEntries = Object.entries(keyLocations);

  const compareFilteredStrings = (a, b, term) => {
    const a0 = a[1].n;
    const b0 = b[1].n;

    const aLower = a0.toLowerCase();
    const bLower = b0.toLowerCase();

    const aStarts = aLower.startsWith(term);
    const bStarts = bLower.startsWith(term);

    if (aStarts && !bStarts) return -1;
    if (!aStarts && bStarts) return 1;

    const aIndex = aLower.indexOf(term);
    const bIndex = bLower.indexOf(term);

    if (aIndex !== bIndex) return aIndex - bIndex;

    return aLower.localeCompare(bLower);
  };


  const searchedGenres = genreEntries
    .filter(([id, data]) =>
      !genres.includes(id) &&
      genreSearch.length >= 2 &&
      data.t == "g" &&
      data.n.toLowerCase().includes(genreSearch.toLowerCase())
    )
    .sort((a, b) => compareFilteredStrings(a, b, genreSearch.toLowerCase()));
  //.sort((a, b) => a[1].n.localeCompare(b[1].n));

  const defaultGenres = genreEntries
    .filter(([id, data]) => !genres.includes(id) && data.k && data.t == "g")
    .sort((a, b) => a[1].n.localeCompare(b[1].n));

  const searchedOTags = genreEntries
    .filter(([id, data]) =>
      !genres.includes(id) &&
      genreSearch.length >= 2 &&
      data.t == "o" &&
      data.n.toLowerCase().includes(genreSearch.toLowerCase())
    )
    .sort((a, b) => compareFilteredStrings(a, b, genreSearch.toLowerCase()));
  //.sort((a, b) => a[1].n.localeCompare(b[1].n));

  const defaultOTags = genreEntries
    .filter(([id, data]) => !genres.includes(id) && data.k && data.t == "o")
    .sort((a, b) => a[1].n.localeCompare(b[1].n));

  const searchedLocations = locationEntries
    .filter(([id, data]) =>
      !locations.includes(id) &&
      locationSearch.length >= 2 &&
      data.n.toLowerCase().includes(locationSearch.toLowerCase())
    )
    //I want to sort by relevance to the search term
    .sort((a, b) => compareFilteredStrings(a, b, locationSearch.toLowerCase()));

  /*{
  const term = locationSearch.toLowerCase();
  const a0 = a[1].n;
  const b0 = b[1].n;

  const aLower = a0.toLowerCase();
  const bLower = b0.toLowerCase();

  const aStarts = aLower.startsWith(term);
  const bStarts = bLower.startsWith(term);

  if (aStarts && !bStarts) return -1;
  if (!aStarts && bStarts) return 1;

  const aIndex = aLower.indexOf(term);
  const bIndex = bLower.indexOf(term);

  if (aIndex !== bIndex) return aIndex - bIndex;

  return aLower.localeCompare(bLower);

})
  */
  //.sort((a, b) => a[1].n.localeCompare(b[1].n));

  const defaultLocations = locationEntries
    .filter(([id, data]) => !locations.includes(id) && data.k)
    .sort((a, b) => a[1].n.localeCompare(b[1].n));

  const searchedRegions = searchedLocations
    .filter(([id, data]) => (("s" in data)));

  const defaultRegions = defaultLocations
    .filter(([id, data]) => (("s" in data)));

  const searchedCountries = searchedLocations
    .filter(([id, data]) => (("d" in data) && data.d == 0 && id in countriesIDs));

  const defaultCountries = defaultLocations
    .filter(([id, data]) => (("d" in data) && data.d == 0 && id in countriesIDs));

  const searchedCities = searchedLocations
    .filter(([id, data]) => (("d" in data) && data.d > 0 && id in citiesIDs));

  const defaultCities = defaultLocations
    .filter(([id, data]) => (("d" in data) && data.d > 0 && id in citiesIDs));


  const searchedOthers = searchedLocations
    .filter(([id, data]) => (!("s" in data) && !(id in citiesIDs) && !(id in countriesIDs)));

  const defaultOthers = defaultLocations
    .filter(([id, data]) => (!("s" in data) && !(id in citiesIDs) && !(id in countriesIDs)));

  //const noLocations = { none: { n: 'No Locations', k: false, d: 0 } };

  //console.log("citiesIDs", Object.keys(citiesIDs).length);


  const generatePlaylist = () => {
    const filters = {
      mode,
      genres,
      yearRange,
      locations,
      popularity,
      sortBy,
      mapOption,
      nearby,
      genreSearch,
      locationSearch,
      showSuggestions,
      openSteps,
      //locationData
    };
    console.log('Generating playlist with filters:', filters);
    submit(filters);
  };

  const clearAll = () => {
    setGenres([]);
    setGenreSearch('');
    setLocations([]);
    setGenreSearch('');
    setLocationSearch('');
    setPopularity(null);
    setShowSuggestions(false);
    setOpenSteps({ 1: true, 2: false, 3: false, 4: false, 5: false, 6: false, 7: true });
    setSortBy(0);
    setMode('top');
    setMapOption(0);
    setYearRange([-40000, 2025]);
  };

  //console.log("Regions", JSON.stringify(defaultLocations, null, 4));
  useEffect(() => {
    setMode(savedState.mode);
    setGenres(savedState.genres || []);
    setGenreSearch(savedState.genreSearch || '');
    setYearRange(savedState.yearRange || [-40000, 2025]);
    setLocations(savedState.locations || []);
    setLocationSearch(savedState.locationSearch || '');
    setPopularity(savedState.popularity || null);
    setSortBy(savedState.sortBy || 0);
    setMapOption(savedState.mapOption || "Below");
    setNearBy(savedState.nearby || false);
    setShowSuggestions(savedState.showSuggestions || false);
    setOpenSteps(savedState.openSteps || { 1: true, 2: false, 3: false, 4: false, 5: false, 6: false, 7: true });
    
  }, [savedState.mode, savedState.genres, savedState.genreSearch, savedState.yearRange, savedState.locations, savedState.locationSearch, savedState.popularity, savedState.sortBy, savedState.mapOption, savedState.nearby, savedState.showSuggestions, savedState.openSteps]);

  //console.log (componentId + " / Saved State:", mode, JSON.stringify(savedState, null, 4));

  return (
    <div className="playlist-filter-container">
      {/* Uncomment this section if you want a clear button */}
      {/*
      <div className="clear-button">
        <button onClick={clearAll}>Clear All</button>
      </div>
*/}
      {/* Step 1 */}
      <section>
        <div className="section-toggle" onClick={() => toggleStep(1)}>
          <h2>Exploration</h2>
        </div>
        {openSteps[1] && (
          <div className="section-content button-group">
            <button onClick={() => setMode('top')} className={`option-button ${mode == 'top' ? 'selected' : ''}`}> TOP </button>
            <button onClick={() => setMode('top+')} className={`option-button ${mode == 'top+' ? 'selected' : ''}`}>Sample</button>
            
            <button onClick={() => setMode('deep')} className={`option-button ${mode == 'deep' ? 'selected' : ''}`}>Deep Dive</button>
            
          </div>
        )}
      </section>

      {/* Step 2 */}
      <section>
        <div className="section-toggle" onClick={() => toggleStep(2)}>
          <h2> Genres </h2>
        </div>
        {openSteps[2] && (
          <div className="section-content">
            <input
              type="text"
              className="search-input"
              value={genreSearch}
              onChange={e => setGenreSearch(e.target.value)}
              placeholder="Search for more genres..."
            />
            <div style={{ paddingBottom: 0 }}></div>
            <div className="button-group">
              {genres.map(id => (

                <button key={id} onClick={() => toggleGenre(id)} className="option-button selected">{keyTags[id].n}</button>
              ))}
            </div>
            <div style={{ paddingBottom: 40 }}></div>
            {((
              (genreSearch.length < 2) ||
              Object.keys(searchedGenres).length > 0
            ) &&
              <span className='span-text' style={{ fontWeight: "bold", paddingBottom: 40 }}> Music Genres </span>
            )}
            <div className="button-group">

              {(genreSearch.length >= 2 ? searchedGenres : defaultGenres).map(([id, data]) => (
                <button key={id} onClick={() => toggleGenre(id)} className="option-button">{data.n}</button>
              ))}
            </div>

            <div style={{ paddingBottom: 40 }}></div>
            {((
              (genreSearch.length < 2) ||
              Object.keys(searchedOTags).length > 0
            ) &&
              <span className='span-text' style={{ fontWeight: "bold", paddingBottom: 40 }}> Context Tags </span>
            )}
            <div className="button-group">
              {(genreSearch.length >= 2 ? searchedOTags : defaultOTags).map(([id, data]) => (
                <button key={id} onClick={() => toggleGenre(id)} className="option-button">{data.n}</button>
              ))}
            </div>
          </div>
        )}
      </section>

      {/* Step 3 */}
      <section>
        <div className="section-toggle" onClick={() => toggleStep(3)}>
          <h2>Years</h2>
        </div>
        {openSteps[3] && (
          <div className="section-content button-group">
            <input type="number" value={yearRange[0]} onChange={e => setYearRange([+e.target.value, yearRange[1]])} className="search-input" style={{ maxWidth: '200px' }} />
            <span className='span-text'>to</span>
            <input type="number" value={yearRange[1]} onChange={e => setYearRange([yearRange[0], +e.target.value])} className="search-input" style={{ maxWidth: '200px' }} />
          </div>
        )}
      </section>

      {/* Step 4 */}
      <section>
        <div className="section-toggle" onClick={() => toggleStep(4)}>
          <h2>Locations</h2>
        </div>
        {openSteps[4] && (
          <div className="section-content">
            <button key="nearBy" onClick={() => toggleNearBy()} className={(!nearby) ? "option-button2" : "option-button2 selected"} > NEAR ME </button>
            <div style={{ padding: 30, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <span className='span-text' style={{ justifyContent: "center" }}> and / or </span>
            </div>
            <input
              type="text"
              className="search-input"
              value={locationSearch}
              onChange={e => setLocationSearch(e.target.value)}
              placeholder="Search for more locations..."
            />
            <div className="button-group">
              {locations.map(id => (
                <button key={id} onClick={() => toggleLocation(id)} className="option-button selected">{keyLocations[id].n}</button>
              ))}
            </div>
            <div style={{ paddingBottom: 20 }}></div>
            <button key="showSuggestions" onClick={() => toggleShowSuggestions()} className={(!showSuggestions) ? "option-button2" : "option-button2 selected"}>
              {(!showSuggestions) ? "Show some popular ones" : "Here is a sample of places"}
            </button>
            <div style={{ paddingBottom: 40 }}></div>
            {((
              (showSuggestions && locationSearch.length < 2) ||
              Object.keys(searchedRegions).length > 0
            ) &&
              <span className='span-text' style={{ fontWeight: "bold", paddingBottom: 40 }}> World Regions </span>
            )}
            <div className="button-group">
              {((!showSuggestions || locationSearch.length >= 2) ? searchedRegions : defaultRegions).map(([id, data]) => (
                <button key={id} onClick={() => toggleLocation(id)} className="option-button">{data.n}</button>
              ))}
            </div>
            <div style={{ paddingBottom: 40 }}></div>
            {((
              (showSuggestions && locationSearch.length < 2) ||
              Object.keys(searchedCountries).length > 0
            ) &&
              <span className='span-text' style={{ fontWeight: "bold" }}> Countries </span>
            )}
            <div className="button-group">
              {((!showSuggestions || locationSearch.length >= 2) ? searchedCountries : defaultCountries).map(([id, data]) => (
                <button key={id} onClick={() => toggleLocation(id)} className="option-button">{data.n}</button>
              ))}
            </div>
            <div style={{ paddingBottom: 40 }}></div>
            {((
              (showSuggestions && locationSearch.length < 2) ||
              Object.keys(searchedCities).length > 0
            ) &&
              <span className='span-text' style={{ fontWeight: "bold" }}> Cities </span>
            )}
            <div className="button-group">
              {((!showSuggestions || locationSearch.length >= 2) ? searchedCities : defaultCities).map(([id, data]) => (
                <button key={id} onClick={() => toggleLocation(id)} className="option-button">{data.n}</button>
              ))}
            </div>

            <div style={{ paddingBottom: 40 }}></div>
            {((
              (showSuggestions && locationSearch.length < 2) ||
              Object.keys(searchedOthers).length > 0
            ) &&
              <span className='span-text' style={{ fontWeight: "bold" }}>Regions | Areas | Schools</span>
            )}
            <div className="button-group">
              {((!showSuggestions || locationSearch.length >= 2) ? searchedOthers : defaultOthers).map(([id, data]) => (
                <button key={id} onClick={() => toggleLocation(id)} className="option-button">{data.n}</button>
              ))}
            </div>
            {/*
            <div className="button-group">
              {(locationSearch.length >= 2 ? searchedLocations : defaultLocations).map(([id, data]) => (
                <button key={id} onClick={() => toggleLocation(id)} className="option-button">{data.n}</button>
              ))}
            </div>
            */}
          </div>
        )}
      </section>

      {/* Step 5 */}
      <section>
        <div className="section-toggle" onClick={() => toggleStep(5)}>
          <h2>Video Views</h2>
        </div>
        {openSteps[5] && (
          <div className="section-content button-group">
            {POPULARITIES.map(level => (
              <button key={level} onClick={() => setPopularity(level)} className={`option-button ${popularity === level ? 'selected' : ''}`}>{level}</button>
            ))}
          </div>
        )}
      </section>

      {/* Step 6 */}
      <section>
        <div className="section-toggle" onClick={() => toggleStep(6)}>
          <h2>Sort By</h2>
        </div>
        {openSteps[6] && (
          <div className="section-content button-group">
            {SORTBY.map(level => (
              <button key={level} onClick={() => setSortBy(level)} className={`option-button ${sortBy === level ? 'selected' : ''}`}>{level}</button>
            ))}
          </div>
        )}
      </section>

      {/* Step 7 */}
      <section>
        <div className="section-toggle" onClick={() => toggleStep(7)}>
          <h2>Map relatively to video</h2>
          {/*
          <span>Deactivate for older devices</span>
          */}
        </div>
        {openSteps[7] && (
          <div className="section-content button-group">
            {MAPOPTIONS.map(level => (
              <button key={level} onClick={() => setMapOption(level)} className={`option-button ${mapOption === level ? 'selected' : ''}`}>{level}</button>
            ))}
          </div>
        )}
      </section>

      {/* Submit */}
      <div style={{ textAlign: 'center', paddingTop: '1.5rem' }}>
        <button className="generate-button" onClick={generatePlaylist}>Generate Playlist</button>
      </div>
    </div>
  );
}

//handling of deep dive
//    "16": "Pop", "352": "R&B", "413": "Country", "567": "Rock", "1434": "Rap"
